module.exports = __webpack_public_path__ + "7e050ebc4857a428be163a5df023d08d.MP3";